module.exports = __webpack_public_path__ + "img/round-volume_up-24px.e7694507.svg";